import React from 'react';
import { Icon, List, Card } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import EditTextModal from '../../../../common/EditTextModal';
import { toastr } from 'react-redux-toastr';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';

class Tags extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openText: false,
            tagName: null,
            tag: null,
            error: null
        }
        this.openTextModal = this.openTextModal.bind(this);
    }

    async componentDidMount() {
        const { history } = this.props;
        if (!this.props.selectedAccount.planId.includes('premium') && !this.props.selectedAccount.planId.includes('enterprise')) {
            history.push(`/app/${this.props.match.params.accountId}/403`)
        }
        dispatch.community.setMainAreaContext("tags");
        if (this.props.match.params.tagId) {
            await dispatch.account.getAccountTags({ query: { parent: this.props.match.params.tagId } })
            await dispatch.account.setSelectedTagById(this.props.match.params.tagId)
        }
        else if (this.props.match.params.baseTagId) {
            await dispatch.account.getAccountTags({ query: { parent: this.props.match.params.baseTagId } })
            await dispatch.account.setSelectedTagById(this.props.match.params.baseTagId)
        }
        else {
            await dispatch.account.getAccountTags()
            await dispatch.account.setSelectedTag({})
        }
    }
    async componentWillReceiveProps(nextProps) {
        if (this.props.match.params.tagId !== nextProps.match.params.tagId || this.props.match.params.baseTagId !== nextProps.match.params.baseTagId) {
            if (nextProps.match.params.tagId) {
                await dispatch.account.getAccountTags({ query: { parent: nextProps.match.params.tagId } })
                await dispatch.account.setSelectedTagById(nextProps.match.params.tagId)
            }
            else if (nextProps.match.params.baseTagId) {
                await dispatch.account.getAccountTags({ query: { parent: nextProps.match.params.baseTagId } })
                await dispatch.account.setSelectedTagById(nextProps.match.params.baseTagId)
            }
            else {
                await dispatch.account.getAccountTags()
                await dispatch.account.setSelectedTag({})
            }
        }
    }

    handleChangeTag(event, data) {
        const { history } = this.props;
        if (data.parent) {
            history.push(`/app/${this.props.match.params.accountId}/settings/tags/${data.parent}/${data._id}`)
        }
        else {
            history.push(`/app/${this.props.match.params.accountId}/settings/tags/${data._id}`)
        }
    }

    async openTextModal(e, openText, tagName, selectedTag) {
        if (openText) {
            try {
                let tag = {};
                tag._id = selectedTag._id;
                tag.prevName = tagName;
                tag.accountId = this.props.match.params.accountId;
                this.setState({
                    openText: openText,
                    tagName: tagName,
                    name: tagName,
                    selectedTag: selectedTag,
                    error: null,
                    description: selectedTag.description
                })
            } catch (error) {
                let message = <div className="confirmMessage">
                    {error.message}
                </div>
                toastr.confirm(message, {
                    onOk: () => { },
                    disableCancel: true
                });
            }
        } else {
            this.setState({
                openText: openText,
                tagName: tagName,
                name: tagName,
                selectedTag: selectedTag,
                error: null
            })
        }
    }

    updateText = (data, name) => {
        this.setState({ name: data, error: null });

    }
    updateDescription = (data) => {
        this.setState({ description: data });
    }

    submitTextModal = async (e, data) => {
        try {
            await dispatch.account.updateTag({ _id: this.state.selectedTag._id, name: this.state.name, description: data.description });
            this.openTextModal(e, false, null, null);
        }
        catch (e) {
            if (e.code === 409) {
                this.setState({ error: { message: "Tag with same name already exist" } })
            }
        }
    }

    getBreadCrumb() {
        const getTagPath = (tagId) => {
            let tag = this.props.tagMap.get(tagId.toString());
            if (tag) {
                if (tag.subTag) {
                    let tagParent = this.props.tagMap.get(tag.parent.toString());
                    let tagGrandParent = this.props.tagMap.get(tagParent.parent.toString());
                    return <React.Fragment><EllipsisTooltip arrowIcon={true} style={{ lineHeight: '18px', float: 'left' }} name={tagGrandParent.name} line={1} />
                        <EllipsisTooltip arrowIcon={true} style={{ width: 'calc(50% - 40px)', lineHeight: '18px', float: 'left' }} name={tagParent.name} line={1} />
                    </React.Fragment>
                }
                else {
                    if (tag.tag) {
                        let tagParent = this.props.tagMap.get(tag.parent.toString());
                        return <React.Fragment><EllipsisTooltip arrowIcon={true} style={{ lineHeight: '18px', float: 'left' }} name={tagParent.name} line={1} />
                            <EllipsisTooltip arrowIcon={true} style={{ width: 'calc(50% - 40px)', lineHeight: '18px', float: 'left' }} name={tag.name} line={1} />
                        </React.Fragment>
                    }
                    else if (tag.baseTag) {
                        return <EllipsisTooltip arrowIcon={true} style={{ width: 'calc(100% - 40px)', lineHeight: '18px', float: 'left' }} name={tag.name} line={1} />
                    }
                }
            }
        }
        if (this.props.selectedTag && this.props.selectedTag._id && this.props.tagMap) {
            return getTagPath(this.props.selectedTag._id)
        }
    }

    render() {
        return (
            <div className="general-setting">
                <Card>
                    <Card.Header>
                        <div className="float-left">
                            Tags
                        </div>
                        {this.getBreadCrumb()}
                    </Card.Header>
                    <Card.Content className="pad_0">
                        <List divided verticalAlign='middle'>
                            {this.props.tags && this.props.tags && this.props.tags.length > 0 ?
                                this.props.tags.map(function (tag, index) {
                                    return (
                                        <List.Item className="singleLine" key={index}>
                                            <List.Content floated='right'>
                                                <Icon className="cursor-pointer" name="pencil" onClick={(e) => this.openTextModal(e, true, tag.name, tag)} />
                                                {!tag.subTag && <Icon className="cursor-pointer" name="chevron right" onClick={(e) => this.handleChangeTag(e, tag)} />}
                                            </List.Content>
                                            <List.Content style={{ width: "calc(100% - 100px)", float: "left" }}>
                                                <List.Header >
                                                    <EllipsisTooltip style={{ width: '50%', lineHeight: '15px' }} name={tag.name} line={1} />
                                                </List.Header>
                                                <List.Description>
                                                    <EllipsisTooltip style={{ width: '100%', lineHeight: '15px' }} name={tag.description} line={1} htmlView={true} />
                                                </List.Description>
                                            </List.Content>
                                        </List.Item>
                                    );
                                }, this) :
                                <List.Item className="singleLine">
                                    <List.Content >
                                        <List.Header >
                                            No tag to display
                                    </List.Header>
                                    </List.Content>
                                </List.Item>}
                        </List>
                    </Card.Content>
                </Card>
                <EditTextModal
                    open={this.state.openText}
                    openTextModal={this.openTextModal}
                    submitTextModal={this.submitTextModal}
                    name="Tag"
                    text={this.state.tagName}
                    onChangeText={this.updateText}
                    error={this.state.error}
                    updateDescription={this.updateDescription}
                    description={this.state.description}
                    descriptionNeeded={true}
                    {...this.props}
                />
            </div>
        );
    }
}

export default withRouter(Tags);